import {memo, useMemo} from "react";
import {useSelector} from 'react-redux';
import {MapContainer, TileLayer,} from "react-leaflet";
import MapObjMarkers from "../MapObjMarkers";
import MapObjRoutes from "../MapObjRoutes";
import MapGeozones from "../MapGeozones";
import MapPoligonDrawing from "../MapPoligonDrawing";
import MapControllerVievport from "../MapControllerVievport";
import MapEventListener from "../MapEventListener";
import mapStateToProps from './mapStateToProps'

const MapContentHolder = ({rangerHeight, geoedit, isGeozonesIntersections, paletteWidth}) => {

    const {
        geoObjs = {},
        routeArr = [],
        routeSettingsArr = [],
        selectedGeoObjArray = [],
        isShowRouteTooltips
    } = useSelector(mapStateToProps)

    const {data: geoArr = []} = geoObjs;
    const rawRoutePoints = []
    const activeRouteArr = routeSettingsArr.reduce((tmpArr, item, i) => {
        if (item.active && routeArr?.[i]) {
            rawRoutePoints.push(...routeArr[i].map(({x, y}) => ({x, y})))
            return [...tmpArr, {...item, route: routeArr[i]}]
        } else {
            return tmpArr
        }
    }, [])

    const routeFilteredBySelectedGeoObject = useMemo(() => {
        const selectedGeoObject = geoObjs?.data?.find(obj => selectedGeoObjArray.includes(obj.id))
        return activeRouteArr?.filter(route => route.name === selectedGeoObject?.name)
    }, [geoObjs, selectedGeoObjArray, activeRouteArr])

    // необходимо для пересечения геозон !!!
    const st = useMemo(() => {
        return {
            bottom: isGeozonesIntersections ? "50%" : "0px"
        }
    }, [isGeozonesIntersections])

    const activePoints = useMemo(() => {
        return geoArr.filter(({id}) => selectedGeoObjArray.includes(id))
    }, [geoArr, selectedGeoObjArray])

    return (
        <div className="mapContainer" style={st}>
            <MapContainer
                className="mapContainerInternal"
                center={[47.2409134, 39.6711311]} zoom={13}
                scrollWheelZoom={true}>
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MapControllerVievport
                    geoedit={geoedit}
                    paletteWidth={paletteWidth}
                    isGeozonesIntersections={isGeozonesIntersections}
                />
                <MapEventListener geoedit={geoedit}/>

                {geoedit ? (
                    <MapPoligonDrawing/>
                ) : (
                    <>
                        <MapGeozones/>
                        <MapObjRoutes
                            activeRouteArr={routeFilteredBySelectedGeoObject}
                            isShowRouteTooltips={isShowRouteTooltips}
                        />
                        <MapObjMarkers activePoints={activePoints}/>
                    </>
                )}

            </MapContainer>
        </div>
    )
}


export default memo(MapContentHolder)